import React from 'react';
import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Lock } from 'lucide-react';
import { Helmet } from 'react-helmet-async';

const LOGO = '/logo.png';

const AdminLogin = () => {
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  const login = () => {
    const redirectUrl = window.location.origin + '/admin/referral-interest';
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-forest-900 px-6" data-testid="admin-login">
      <Helmet>
        <title>Admin Sign In | Forever Path Living™</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <Card className="w-full max-w-md p-10 bg-cream-100 border border-sage-200 rounded-3xl text-center shadow-2xl">
        <img src={LOGO} alt="Forever Path Living" className="h-16 mx-auto mb-6 object-contain" />
        <div className="inline-flex p-3 rounded-2xl bg-sage-100 text-forest-700 mb-4"><Lock className="w-6 h-6" /></div>
        <h1 className="font-serif text-2xl text-forest-800 mb-2">Administrator Access</h1>
        <p className="text-forest-700 mb-8 text-sm leading-relaxed">
          This area contains confidential referral information and is restricted to authorized staff only.
          Please sign in with the administrator Google account.
        </p>
        <Button onClick={login} data-testid="google-login-btn"
          className="w-full rounded-full bg-forest-800 hover:bg-forest-900 text-cream-100 py-6 text-base font-semibold">
          Sign in with Google
        </Button>
      </Card>
    </div>
  );
};

export default AdminLogin;
